/**
 * Query Key Factory
 * Eliminates duplicate query key definitions across hooks.
 * Each hook's keys object extends the base with entity-specific keys.
 *
 * @example
 * const base = createQueryKeys('policies');
 * export const policyKeys = {
 *   ...base,
 *   fireZone: (id: string) => [...base.all, 'fire-zone', id] as const,
 * };
 */

export function createQueryKeys<T extends string>(entity: T) {
  const all = [entity] as const;
  return {
    all,
    lists: () => [...all, 'list'] as const,
    list: (params: Record<string, unknown>) => [...all, 'list', params] as const,
    details: () => [...all, 'detail'] as const,
    detail: (id: string) => [...all, 'detail', id] as const,
  };
}
